import {
    mapGetters
} from 'vuex';

export default {

    computed: {
        ...mapGetters({
            isDsApp: 'isApp',
            isDsAndroidApp: 'isAndroidApp',
            isDsIosApp: 'isIosApp',
            appName: 'appName'
        })
    },
    methods: {
        /**
         * 显示APP加载的toast
         * @param {String} text 加载的文本
         */
        showAppLoading(text = '') {
            webridge.jsToNative({
                handler: 'CommonUI',
                action: 'loadingControl',
                params: {
                    "loading": true,
                    "error": false
                }
            });
        },

        /**
         * 隐藏APP加载的toast
         */
        hideAppLoading() {
            if (this.isDsApp) {
                webridge.jsToNative({
                    handler: 'CommonUI',
                    action: 'loadingControl',
                    params: {
                        "loading": false,
                        "error": false
                    }
                });
            }
        },

        /**
         * 关闭App的加载，因为App无法监听到页面是否渲染完毕，需要h5主动触发。
         * 可以在mounted声明周期函数中调用
         */
        closeAppLoading() {
            this.$webridge.hideLoadingControl();
        },

        /**
         * 设置Apptitle
         * @param {String} title 标题
         */
        setAppTitle(title) {
            webridge.jsToNative({
                handler: 'CommonUI',
                action: 'setTitle',
                params: {
                    title
                }
            });
            document.title = title
        },

        /**
         * 跳转登录
         */
        gotoLoginPage() {
            if (this.isDsApp) {
                let lackey = 'login';
                console.log('DEBUG_LOG:call gotoLoginPage', `dyxc://com.dbj.app/view/in/${lackey}`);

                webridge.jsToNative({
                    handler: "Common",
                    action: "login",
                    params: {}
                });
            } else {
                console.log('DEBUG_LOG:abort login', null);
            }
        },
        /**
         * 跳转下一页
         * @param {String} url 页面路由path
         * @param {Object} params_ 
         * @param {String} lackey 指定一个特定的客户端标识替代web/hybrid
         */
        toNext(url, params_, lackey) {
            if (this.isDsApp) {
                let urlLink = '';
                if (params_) {
                    for (const key in params_) {
                        urlLink += '&' + key + "=" + params_[key];
                    }
                    urlLink = urlLink.substr(1);
                }

                const toUrl = window.location.origin + process.env.VUE_APP_ROUTER_PATH + url + "?" + urlLink;
                lackey = lackey || 'web/hybrid';
                let finalUrl = `dyxc://com.dbj.app/view/in/${lackey}?url=` + encodeURIComponent(toUrl)
                console.log('DEBUG_LOG:to next finalUrl', finalUrl);

                webridge.jsToNative({
                    handler: 'Common',
                    action: 'exeRouter',
                    params: {
                        url: finalUrl
                    }
                });
            } else {
                this.$router.push({
                    path: url,
                    query: params_
                })
            }
        },

        /**
         * APP关闭当前页面 h5 执行back();
         */
        closePage() {
            if (this.isDsApp) {
                webridge.jsToNative({
                    handler: 'CommonUI',
                    action: 'closePage',
                });
            } else {
                this.$router.back();
            }
        },

        /**
         * 替换当前页
         * @param {String} url 标题
         */
        toNextReplace(url, params_) {
            if (this.isDsApp) {

                this.$router.replace({
                    path: url,
                    query: params_
                })

                return

                let urlLink = '';
                if (params_) {
                    for (const key in params_) {
                        urlLink += '&' + key + "=" + params_[key];
                    }
                    urlLink = urlLink.substr(1);
                }

                const toUrl = window.location.origin + process.env.VUE_APP_ROUTER_PATH + url + "?" + urlLink;
                console.log(toUrl);

                return
                window.location.replace = toUrl;
            } else {
                this.$router.replace({
                    path: url,
                    query: params_
                })
            }

        },

        /**
         * 设置app去首页
         */
        toHome() {
            if (this.isDsApp) {
                webridge.jsToNative({
                    handler: 'Common',
                    action: 'exeRouter',
                    params: {
                        url: 'dsedu://com.zhugexuetang.zwwlapp/view/root/page?secLevelViewK=selectCourse'
                    }
                });
            } else {
                this.$router.replace('index')
            }
        },

        /**
         * 去登录(新)
         * @param {String}  标题
         */
        toAppHome() {
            const liveBridgeUrl = 'zwwl://com.zwwl.live/view/root/page?secLevelViewK=selectCourse';
            const educationBridgeUrl = 'dsedu://com.zhugexuetang.zwwlapp/view/root/page?secLevelViewK=selectCourse'; //待定
            if (this.isDsApp) {
                webridge.jsToNative({
                    handler: 'Common',
                    action: 'exeRouter',
                    params: {
                        url: `${this.appName == 'zwwl_education'?educationBridgeUrl: liveBridgeUrl}`
                    }
                });
            } else {
                this.$router.replace('index')
            }
        },

        /**
         * 去登录
         * @param {String}  标题
         */
        toAppLogin() {
            webridge.jsToNative({
                handler: 'Common',
                action: 'tryLogin',
            });
        },

        /**
         * 设置存储
         */
        setStorage(key_, value_) {
            if (this.isDsApp) {
                localStorage.setItem(key_, value_)
                // webridge.jsToNative({
                //     handler: 'Storage',
                //     action: 'setValueByKey',
                //     params: {
                //         "name": key_,
                //         "value": encodeURI(value_)
                //     }
                // });
            } else {
                localStorage.setItem(key_, value_);
            }
        },


        /**
         * 获取存储
         */
        getStorage(key_) {
            if (this.isDsApp) {
                console.log('h5_get_Storage')
                return localStorage.getItem(key_)
            } else {
                return localStorage.getItem(key_)
            }
        },


        /**
         * 删除存储
         */
        delStorage(key_) {
            if (this.isDsApp) {
                localStorage.removeItem(key_)
                // webridge.jsToNative({
                //     handler: 'Storage',
                //     action: 'deleteValueByKey',
                //     params: {
                //         "name": key_,
                //     }
                // });
            } else {
                localStorage.removeItem(key_);
            }
        },

        /**
         * 跳转下一页
         * @param {String} url 标题
         */
        toAppNext(url, params_, contract) {
            if (this.isDsApp) {
                let urlLink = '';
                if (params_) {
                    for (const key in params_) {
                        urlLink += '&' + key + '=' + params_[key];
                    }
                    urlLink = urlLink.substr(1);
                }
                const toUrl = window.location.origin + process.env.VUE_APP_ROUTER_PATH + url + '?' + urlLink;
                const educationBridgeUrl = 'dsedu://com.zhugexuetang.zwwlapp/view/webview/hybrid?url=';
                const liveBridgeUrl = 'zwwl://com.zwwl.live/view/webview/hybrid?url=';

                webridge.jsToNative({
                    handler: 'Common',
                    action: 'exeRouter',
                    params: {
                        url: `${this.appName == 'zwwl_education' ? educationBridgeUrl : liveBridgeUrl}` + encodeURIComponent(toUrl)
                    }
                });
            } else {
                this.$router.push({
                    path: url,
                    query: params_
                });
            }
        },
        /**
         * 数据埋点
         * @param {String} eventID 事件ID
         */
        buryingPoint(eventID) {
            console.log('DEBUG_LOG:buryingPoint', eventID);
            if (this.isDsApp) {
                webridge.jsToNative({
                    handler: "Common",
                    action: "buryingPoint",
                    params: {
                        "id": eventID
                    }
                });
            }
        }
    }
};